<script>
    import { page } from '$app/stores';
    import { unp_json } from '$lib/static/unp_json.js'
    import { tooltip } from '$lib/app/tooltip.js';

    import Paginator from '$lib/Paginator.svelte';
    import Flag from '$lib/app/Flag.svelte';
    import Page from '$lib/Page.svelte';
    import MainMenu from '$lib/MainMenu.svelte';

    let { data } = $props();

    let by = $derived($page.params.by);
    let pageno = $derived($page.params.page);
    let from = $derived($page.params.from);
</script>
<MainMenu session={data.session}/>
<Page long_page_footer={true}>

    <h1 class="title fr1">Top travellers</h1>
    <h2 class="subtitle fr2">{#if from && unp_json[from]?.name}From {unp_json[from].name}<br>{/if}{@html data.order_txt[by]}</h2>
    <div class="content">
        <!--RankingPage bind:data by={$page.params.by} page={$page.params.page}/-->
        <table class="table is-striped is-hoverable ranking-table">
            <thead>
                <tr>
                    <th class="has-text-right pl-0 w8pt">#</th>
                    <th>user</th>
                    <th class="has-text-right sortable w8pt" data-sveltekit-replacestate class:sortable-selected={by=="by-un"}><a href="/ranking/by-un/{from}/{pageno}">UN</a></th>
                    <th class="has-text-right sortable w8pt is-hidden-mobile" data-sveltekit-replacestate class:sortable-selected={by=="by-un-plus"}><a href="/ranking/by-un-plus/{from}/{pageno}">UN+</a></th>
                    <th class="has-text-right sortable w8pt is-hidden-mobile" data-sveltekit-replacestate class:sortable-selected={by=="by-tcc"}><a href="/ranking/by-tcc/{from}/{pageno}">TCC</a></th>
                    <th class="has-text-right sortable w8pt" data-sveltekit-replacestate class:sortable-selected={by=="by-reg"}><a href="/ranking/by-reg/{from}/{pageno}">Reg</a></th>
                    <th class="has-text-right sortable w8pt" data-sveltekit-replacestate class:sortable-selected={by=="by-cities"}><a href="/ranking/by-cities/{from}/{pageno}">📍</a></th>
                </tr>
            </thead>
            <!-- foreach -->
            <tbody>
            {#if data?.rows}<!--{#if data?.page_data}-->
                {#each data?.rows as item}<!--{#each data?.page_data as item}-->
                    <tr class:is-me={item?.is_me}>
                        <td class="has-text-right w8pt pl-0" class:is-deleted={item?.deleted}>{item?.rank}.</td>
                        <td><a class:is-deleted={item?.deleted} class:has-text-success={item?.new_user} href="/user/{item?.userpage}">{item?.displayname?.replace(/([a-z])([@A-Z])/, "$1\u200B$2")}</a>
                            <a href="/ranking/{by}/{item?.from1}/1"><Flag reg={item?.from1} width=auto template="From %s"/></a>
                            <a href="/ranking/{by}/{item?.from2}/1"><Flag reg={item?.from2} width=auto template="Also from %s"/></a>
                            {#if item?.is_me && (data.session?.visibility > 1 || data.session?.deleted || item?.places < 10)}
                                &nbsp;<span use:tooltip
                                data-tooltip={
                                    data.session?.deleted ?
`Your page is excluded from the Top
because it's deleted
` :
                                    item?.places < 10 ?
`Your page is excluded from the Top
because you've been to less then 10 places
` :
                                    data.session.visibility === 2 ?
`Your ranking is visible to logged in users only
because of "Show my map to"
in your Profile Settings`
                                :
`Your page is excluded from the Top
because of "Show my map to"
in your Profile Settings`
                                }><svg class=svg-icon><use xlink:href="/i/fa.svg#eye-slash"/></svg></span>
                            {/if}
                        </td>
                        <td class:is-deleted={item?.deleted} class:has-text-success={item?.un_up} class="has-text-right w8pt">{item?.un || 0}</td>
                        <td class:is-deleted={item?.deleted} class:has-text-success={item?.unp_up} class="has-text-right w8pt is-hidden-mobile">{item?.unp || 0}</td>
                        <td class:is-deleted={item?.deleted} class:has-text-success={item?.tcc_up} class="has-text-right w8pt is-hidden-mobile">{item?.tcc || 0}</td>
                        <td class:is-deleted={item?.deleted} class:has-text-success={item?.reg_up} class="has-text-right w8pt">{item?.reg || 0}</td>
                        <td class:is-deleted={item?.deleted} class:has-text-success={item?.places_up} class="has-text-right w8pt">{item?.places || 0}</td>
                    </tr>
                {/each}
            {/if}
            </tbody>
        </table>
        <!--Paginator current_page={pageno} total_pages={data?.page_summary?.total_pages} /-->
        <Paginator current_page={pageno} total_pages={data?.total_pages} important_page={data?.important_page}/>
    </div>
</Page>

<style>
.w8pt {
    width: 8%;
}

tr.is-me {
    background: #EBFFDE !important;
}

table.ranking-table {
    max-width: 750px;
}

th.sortable > a {
    text-decoration: none;
    border-bottom: 1px dashed;
    color: inherit;
    cursor: s-resize;
}

th.sortable-selected > a {
    border-bottom: none !important;
}

@media (prefers-color-scheme: dark) {
    tr.is-me {
        background: rgb(50, 60, 80) !important;
    }
}

.is-deleted {
    text-decoration: line-through;
}

</style>
